import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/users/(org-users)/$orgUserId/$userId",
)({
	component: RouteComponent,
	params: {
		parse: (params) => ({
			userId: z.string().parse(params.userId),
		}),
	},
});

function RouteComponent() {
	return <Outlet />;
}
